const size = {
  mobileS: "0px",
  mobileM: "375px",
  mobileL: "475px",
  smMaterialUI: "599px",
  tablet: "768px",
  tabletL: "981px",
  laptop: "1024px",
  laptopL: "1440px",
  desktop: "1821px",
  desktopL: "2560px"
};

const deviceSize = {
  mobileS: `(max-width: ${size.mobileS})`,
  mobileM: `(max-width: ${size.mobileM})`,
  mobileL: `(max-width: ${size.mobileL})`,
  smMaterialUI: `(max-width: ${size.smMaterialUI})`,
  tablet: `(max-width: ${size.tablet})`,
  tabletL: `(max-width: ${size.tabletL})`,
  laptop: `(max-width: ${size.laptop})`,
  laptopL: `(max-width: ${size.laptopL})`,
  desktop: `(max-width: ${size.desktop})`,
  desktopL: `(max-width: ${size.desktopL})`
};

module.exports = {
  deviceSize,
}